import { ACTION_SUBJECT_PREFIX } from '../../constants/analytics';
import { type FireAnalyticsEvent } from '../../types';

import { type CommonAttributes, type NonPrivacySafeAttributes } from './types';

type onDropdownDwelledArgs = {
	commonAttributes: CommonAttributes;
	nonPrivacySafeAttributes: NonPrivacySafeAttributes;
	dwellTime: number;
};

export const onDropdownDwelled = ({
	commonAttributes,
	nonPrivacySafeAttributes,
	dwellTime,
}: onDropdownDwelledArgs): FireAnalyticsEvent => ({
	eventType: 'track',
	actionSubject: `${ACTION_SUBJECT_PREFIX}Dropdown`,
	action: 'dwelled',
	attributes: {
		additionalAttributes: {
			dwellTime,
		},
		commonAttributes,
	},
	nonPrivacySafeAttributes,
});
